/**
 *  API 统一管理
 * */
import $axios from '@/service/httpServer';

// 用户
export * from './modules/user';
// 获取数据字典
export * from './modules/dataDictionary';
// 组织
export * from './modules/organization-manage';

// 获取左侧菜单
export const getAuthResourceTree = code =>
  $axios.get('/uc/auth/tree/' + code);

// 应用全限管理
export const getAppList = sendData =>
  $axios.get('/uc/sys/app/listNotPage', sendData); // 获取应用列表

// 获取权限码列表
export const getUserPermission = appId =>
  $axios.get('/auth/user/permissions', { appCode: 'upms', appId: appId || '' }); // 获取用户权限列表

// 获取 ossToken
export const getOssToken = () =>
  $axios.get('/prov-base/portal/jxOssToken');

//组织树（完整）
export const getWholeOrgTree = p =>
  $axios.get('/work/common/oa/getOrganizationTree', p);
// 获取岗位列表
export const getPositionList = p => $axios.post('/upms/position/list', p);
// 新用户中心 获取系统列表
export const getSourceMap = data => $axios.get('/uc/sys/app/getOrgTags', data);
